import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Label, Modal, Button} from "reactstrap";
import {Formik, Field, Form, ErrorMessage} from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import {notificationsGroupList, notificationsNew, notificationsUserList} from "../../store/notifications/actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import SelectField from "../../components/Common/SelectField";
import SwitchField from "../../components/Common/SwitchField";

class NewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: "",
      userOptions: [],
      loadingUserList: false,
      errorUserList: "",
      groupOptions: [],
      loadingGroupList: false,
      errorGroupList: "",
      user: null,
      group: null,
    }

    this.onUserChange = this.onUserChange.bind(this)
    this.onGroupChange = this.onGroupChange.bind(this)
  }

  componentDidMount() {
    this.props.onNotificationsUserList({history: this.props.history});
    this.props.onNotificationsGroupList({history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        loading: this.props.loading,
        error: this.props.error,
        userOptions: this.props.responseUserList ? this.props.responseUserList.response : [],
        loadingUserList: this.props.loadingUserList,
        errorUserList: this.props.errorUserList,
        groupOptions: this.props.responseGroupList ? this.props.responseGroupList.response : [],
        loadingGroupList: this.props.loadingGroupList,
        errorGroupList: this.props.errorGroupList,
      });
      if (this.props.response.status === 0) {
        this.props.refreshParent({history: this.props.history})
        this.onClose()
      }
    }
  }

  onClose = () => {
    this.props.togModal()
  }

  onUserChange = (newValue, setFieldValue) => {
    setFieldValue("group", null)
    this.setState({
      user: newValue,
    });
  }

  onGroupChange = (newValue, setFieldValue) => {
    setFieldValue("user", null)
    this.setState({
      group: newValue,
    });
  }

  render() {
    const typeOptions = [
      {label: 'success', value: '0'},
      {label: 'info', value: '1'},
      {label: 'warning', value: '2'},
      {label: 'error', value: '3'}
    ];

    Yup.addMethod(Yup.object, "userSelected", function (data) {
      return this.test(`userSelected`, data, function (value) {
        const {path, createError} = this
        return (value || data.group || createError({path, message: data.message}))
      })
    })

    Yup.addMethod(Yup.object, "groupSelected", function (data) {
      return this.test(`groupSelected`, data, function (value) {
        const {path, createError} = this
        return (value || data.user || createError({path, message: data.message}))
      })
    })

    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">New Notification</h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Formik
          initialValues={{
            title: "",
            message: "",
            type: typeOptions[0],
            is_important: false,
            user: null,
            group: null,
          }}
          validationSchema={Yup.object().shape({
            title: Yup.string().min(3, 'Title Is Too Short').max(32, 'Title Is Too Long').required("Please Enter Title"),
            message: Yup.string().min(3, 'Message Is Too Short').max(128, 'Message Is Too Long').required("Please Enter Message"),
            type: Yup.object().typeError("Please Enter Type").required("Please Enter Type"),
            user: Yup.object().nullable(true).userSelected({message: "Please enter user or group", group: this.state.group}),
            group: Yup.object().nullable(true).groupSelected({message: "Please enter user or group", user: this.state.user}),
          })}
          onSubmit={values => {
            this.props.onNotificationsNew({
              values: {
                title: values.title,
                message: values.message,
                type: values.type.value,
                user_id: values.user ? values.user.value : null,
                group_id: values.group ? values.group.value : null,
                is_important: values.is_important,
              },
              history: this.props.history,
            })
          }}
        >
          {({errors, status, touched, setFieldValue}) => (<Form>
            <div className="modal-body">
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="title">
                      Title
                    </Label>
                    <Field
                      id="title"
                      name="title"
                      placeholder="Enter Title"
                      type="text"
                      className={"form-control" + (errors.title && touched.title ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="message">
                      Message
                    </Label>
                    <Field
                      id="message"
                      name="message"
                      placeholder="Enter Message"
                      type="text"
                      className={"form-control" + (errors.message && touched.message ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <SelectField label="Type" name="type" options={typeOptions}/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <SelectField label="User" name="user" options={this.state.userOptions} onChange={(value) => this.onUserChange(value, setFieldValue)}/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <SelectField label="Group" name="group" options={this.state.groupOptions} onChange={(value) => this.onGroupChange(value, setFieldValue)}/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <SwitchField id="is_important" name="Important" color="#02a499"/>
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {(this.state.loading || this.state.loadingUserList || this.state.loadingGroupList) && (
                <div className="spinner-border text-primary m-1 me-auto" role="status">
                  <span className="sr-only">Loading...</span>
                </div>)}
              {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                {this.state.error}
              </Alert>)}
              {this.state.errorUserList.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                {this.state.errorUserList}
              </Alert>)}
              {this.state.errorGroupList.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                {this.state.errorGroupList}
              </Alert>)}
              <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
                Close
              </Button>
              <Button color="primary" type="submit">
                Save
              </Button>
            </div>
          </Form>)}
        </Formik>
      </Modal>
    </React.Fragment>)
  }
}

NewModal.propTypes = {
  response: PropTypes.any,
  responseUserList: PropTypes.any,
  responseGroupList: PropTypes.any,
  onNotificationsNew: PropTypes.func,
  onNotificationsUserList: PropTypes.func,
  onNotificationsGroupList: PropTypes.func,
};

const mapStateToProps = ({Notifications}) => ({
  response: Notifications.responseNew,
  loading: Notifications.loadingNew,
  error: Notifications.errorNew,
  responseUserList: Notifications.responseUserList,
  loadingUserList: Notifications.loadingUserList,
  errorUserList: Notifications.errorUserList,
  responseGroupList: Notifications.responseGroupList,
  loadingGroupList: Notifications.loadingGroupList,
  errorGroupList: Notifications.errorGroupList,
});

const mapDispatchToProps = dispatch => ({
  onNotificationsNew: data => dispatch(notificationsNew(data)),
  onNotificationsUserList: data => dispatch(notificationsUserList(data)),
  onNotificationsGroupList: data => dispatch(notificationsGroupList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewModal));
